export interface MapActions {
  type: string;
  payload?: any;
}

export const MapActionsTypes = {
  SET_MAP: 'SET_MAP',
  CURRENT_MAP_ID: 'CURRENT_MAP_ID',
  CURRENT_MAP_STYLE: 'CURRENT_MAP_STYLE',
  SHOW_MAP: 'SHOW_MAP',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_FILTER: 'HIDE_FILTER',
  SET_FILTER_MODAL_SIZE: 'SET_FILTER_MODAL_SIZE',
  SET_POPUP_POSITION: 'SET_POPUP_POSITION',
};
